import { GitBranch, MessageSquare, User, Zap } from "lucide-react";

const ACTIVITY_ICONS = {
  workflow: GitBranch,
  manual: User,
  campaign: MessageSquare,
  system: Zap,
};

export default function ContactActivityLog({ activities }) {
  if (!activities?.length) return null;

  return (
    <div className="bg-white dark:bg-slate-900 p-4 rounded-xl border border-gray-200 dark:border-slate-800 shadow-sm space-y-4">
      <h3 className="font-semibold text-gray-900 dark:text-white text-sm">
        Activity &amp; Data Source
      </h3>
      <div className="space-y-4 relative before:absolute before:inset-0 before:ml-[11px] before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-gray-100 dark:before:via-slate-700 before:to-transparent">
        {activities.map((activity, idx) => {
          const Icon = ACTIVITY_ICONS[activity.type] || Zap;

          return (
            <div
              key={`${activity.title}-${idx}`}
              className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group"
            >
              <div className="flex items-center justify-center w-6 h-6 rounded-full border border-white dark:border-slate-900 bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-slate-400 shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2">
                <Icon className="w-3 h-3" />
              </div>
              <div className="w-[calc(100%-2.5rem)] md:w-[calc(50%-1.5rem)] p-3 rounded-lg border border-gray-100 dark:border-slate-800 bg-gray-50/50 dark:bg-slate-950/50 shadow-sm">
                <div className="flex items-center justify-between mb-1 gap-2">
                  <div className="font-medium text-xs text-gray-900 dark:text-white">
                    {activity.title}
                  </div>
                  <time className="text-[10px] text-gray-500 dark:text-gray-400 font-medium shrink-0">
                    {activity.time}
                  </time>
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  {activity.description}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
